package com.example.mystybag.core.logic.base

import com.example.mystybag.core.logic.helpers.DialogResult
import com.example.mystybag.core.model.SnackbarConfig
import kotlin.reflect.KClass

interface FrameworkInterface {
    fun showSnackbar(config: SnackbarConfig)

    //for debug purposes only
    fun dumpNavigationStack()

    fun navigateTo(config: FeatureManager, callback: ParentCallback? = null)
    fun replaceCurrent(config: FeatureManager, callback: ParentCallback? = null)
    fun navigateBack()
    fun getTopViewModel(): BaseViewModel?
    fun bringToFront(config: NavigatorConfig, callback: ParentCallback? = null)
    fun isMainInStack(): Boolean
    suspend fun displayDialog(config: DialogConfig): DialogResult
    fun baseBottomSheetDidClose(): Boolean
    fun setDarkTheme(isDark: Boolean)
    /***
     * check if the specified Navigator is present (ONLY) in the AppViewModel's navigation stack, i.e.
     * screen pushed thru AppViewModel.navigateTo(...), AppViewModel.replaceCurrent(...) etc.
     * Useful to check if a Feature is already opened
     */
    fun <T: NavigatorConfig> navigatorIsOpen(clazz: KClass<T>): Boolean
}